export interface UmpireMatchStat {
  ball_possession: string | undefined;

  corner_kicks: string | undefined;

  crosses: string | undefined;

  crosses_accurate: string | undefined;

  fouls: string | undefined;

  offsides: string | undefined;

  passes: string | undefined;

  passes_accurate: string | undefined;

  shots: string | undefined;

  shots_on_target: string | undefined;

  shots_off_target: string | undefined;

  shots_blocked: string | undefined;

  tackles_successful: string | undefined;

  squad_id: number | undefined;

  yellow_cards: string | undefined;

  red_cards: string | undefined;
}
